import { StringService as StringHelper } from '@rocheglobal/component-library/src/services/string/index';

const getPreviousPageData = () => {
  const previousPage = sessionStorage.getItem('previousPage');

  return previousPage
    ? JSON.parse(previousPage)
    : {
      url: '',
      path: '',
      pageTitle: '',
      pageName: '',
      mainCategory: '',
      categoryTree: '',
    };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const storePageData = (pageData: any) => {
  sessionStorage.setItem('previousPage', JSON.stringify({
    url: pageData.url,
    path: pageData.path,
    pageTitle: pageData.pageTitle,
    pageName: pageData.pageName,
    mainCategory: pageData.mainCategory,
    categoryTree: pageData.categoryTree,
  }));
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getAllAssets = (data: any) => {
  const result: { type: string; name: string }[] = [];

  function findRecursive(items) {
    if (Array.isArray(items)) {
      items.forEach(findRecursive);
    } else if (typeof items === 'object' && items !== null) {
      if (items.component === 'roche-video-player') {
        const type = 'video';
        const name = items.preview?.name || '';
        if (type || name) {
          result.push({ type, name });
        }
      }

      if (items.tagName === 'iframe' && items['data-type'] === 'audio') {
        result.push({ type: 'audio', name: '' });
      }

      // Recursively check nested properties
      Object.values(items).forEach(findRecursive);
    }
  }

  findRecursive(data);
  return result;
};

const getUrlFirstPathOrHome = (url: string): string => {
  const parsedUrl = new URL(url);
  const segments = parsedUrl.pathname.split('/').filter(Boolean);

  // Return the first segment capitalized or 'Home' if no valid segment exists
  return segments.length > 0 ? StringHelper.capitalize(segments[0]) : 'Home';
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const page = (data: any) => {
  const { story } = data;

  const previousPage = getPreviousPageData();

  const pageData = {
    ...(data.scrolled && { scrolled: data.scrolled }),
    ...(data.error && { error: data.error }),
    ...(data.errorType && { errorType: data.errorType }),
    siteName: data.websiteName?.toLowerCase() || '',
    sysEnv: process.env.GATSBY_WEBSITE_STAGE || '',
    market: 'DE',
    language: story?.lang || data?.locale || '',
    url: window.location.href,
    domain: window.location.host,
    path: window.location.pathname,
    pageTitle: story?.content.meta_tags?.title || document.title || '',
    pageName: story?.name || '',
    uuid: story?.uuid || '',
    protected: 'public',
    referrer: document.referrer,
    mainCategory: getUrlFirstPathOrHome(window?.location?.href) || '',
    categoryTree: data?.breadcrumbs?.map((item) => item.name).join('|') || '',
    previousPage,
    ...(!data.scrolled && { media: getAllAssets(story?.content?.body) }),
  };

  storePageData(pageData);

  return pageData;
};
